import { SeverityLevel } from '@sentry/react';

import { Sentry } from '@//infra/observability/sentry/instance';
import { BreadcrumbCategory } from '@//infra/observability/sentry/types/breadcrumb';

export function addBreadcrumb(message: string, level: SeverityLevel, category: BreadcrumbCategory) {
  Sentry.addBreadcrumb({ timestamp: Math.floor(Date.now() / 1000), category, message, level });
}
